export const TRIGGER_TYPES = [
  {
    label: 'Form Submission',
    value: 'form_submission',
  },
  {
    label: 'Lead Status Change',
    value: 'status_change',
  },
  {
    label: 'Deal aangemaakt',
    value: 'deal_created',
  },
  {
    label: 'Deal Status Change',
    value: 'deal_status_change',
  },
  {
    label: 'Offerte geaccepteerd',
    value: 'proposal_accepted',
  },
  {
    label: 'Offerte afgewezen',
    value: 'proposal_rejected',
  },
  {
    label: 'Offerte status wijziging',
    value: 'proposal_status_change',
  },
  {
    label: 'Project status wijziging',
    value: 'project_status_change',
  },
  {
    label: 'Projectstatus: afgerond',
    value: 'project_fully_completed',
  },
  {
    label: 'Werkbon afgerond',
    value: 'work_order_completed',
  },
  {
    label: 'Bezoek bevestigd',
    value: 'work_visit_confirmed',
  },
  {
    label: 'Bezoek afgerond',
    value: 'work_visit_completed',
  },
  {
    label: 'Alle werkbonnen afgerond',
    value: 'project_all_work_orders_completed',
  },
  { label: 'Scheduled Event', value: 'scheduled_event' },
];
